import {ModuleWithProviders, NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {LaAvatarComponent} from './la-avatar.component';
import {LaImageModule} from '../image/la-image.module';

// Export module's public API
@NgModule({
  imports: [CommonModule, LaImageModule],
  declarations: [LaAvatarComponent],
  exports: [LaAvatarComponent]
})
export class LaAvatarModule {
  static forRoot(): ModuleWithProviders {
    return {
      ngModule: LaAvatarModule,
      providers: []
    }
  }
}
